import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { interpolate } from "@/helpers"

type FetchParams = {
  merchantId?: string
  domain?: string
}

const fetchWhitelabelConfiguration = async ({
  merchantId,
  domain,
}: FetchParams): Promise<
  WhitelabelConfiguration | DomainConfiguration | null
> => {
  if (merchantId) {
    const url = interpolate(
      ENDPOINTS.WHITELABEL_CONFIGURATION_BY_MERCHANT,
      { merchantId }
    )
    const { data } =
      await api.get<WhitelabelConfiguration>(url)
    return data
  }

  if (domain) {
    const url = interpolate(
      ENDPOINTS.WHITELABEL_CONFIGURATION,
      { domain }
    )
    const { data } = await api.get<DomainConfiguration>(url)

    if (data.success === false) {
      return null
    }

    return data
  }

  throw new Error(
    "Either merchantId or domain must be provided"
  )
}

const useWhitelabelConfiguration = (
  params: FetchParams,
  enabled = true
) => {
  const queryKey = params.merchantId
    ? [
        "whitelabel-configuration",
        "merchant",
        params.merchantId,
      ]
    : ["whitelabel-configuration", "domain", params.domain]

  const isParamsValid = !!(
    params.merchantId || params.domain
  )

  return useQuery({
    queryKey,
    queryFn: () => fetchWhitelabelConfiguration(params),
    enabled: isParamsValid && enabled,
    // Sem cache de 1h (decisão da doc WHITE_LABEL_ADMIN §6): mudança
    // de tema/logo feita no painel admin reflete no próximo load,
    // sem janela de 1h de tema velho.
    staleTime: 0,
    gcTime: 0,
    retry: false,
    meta: {
      skipErrorNotification: true,
    },
  })
}

export default useWhitelabelConfiguration
